<template>
    <div class="app-progress-bar">
        <el-progress
            :percentage="percentage"
            :color="_customProgressColor"
        />
    </div>
</template>

<script>
export default {
    name: 'ProcessBar',
    props: {
        percentage: {
            type: Number,
            default: 0
        }
    },
    methods: {
        _customProgressColor() {
            if (this.percentage < 30) {
                return '#909399';
            } else if (this.percentage < 70) {
                return '#e6a23c';
            } else {
                return '#67c23a';
            }
        }
    }
};
</script>

<style lang="scss">
.app-progress-bar {

}
</style>
